import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputEMailVorlagenAnhangAdd<T extends EMode = EMode.entity> {
  /** Alias: tempFileId */
  tempFileId?: string;
  /** Alias: eMailAttachementId */
  eMailAttachementId?: string;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputEMailVorlagenAnhangAdd> = {
  tempFileId: {
    alias: 'tempFileId',
  },
  eMailAttachementId: {
    alias: 'eMailAttachementId',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputEMailVorlagenAnhangAddEntityDefinition: EntitiyDefinition<InputEMailVorlagenAnhangAdd> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputEMailVorlagenAnhangAdd',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
